<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-06 15:29:15
 * @FilePath: \YunYin_admin\src\views\Cooperative\Log\List.vue
-->
<template>
  <LogList :dataSource="3"></LogList>
</template>

<script>
import LogList from "@/components/Query/LogList";
export default {
  name: "CooperativeLogList",
  data() {
    return {};
  },
  components: { LogList },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
